// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"442":"2969bd6e","484":"bfcbf6fe","634":"0e49956c","688":"0c881b3d"}[chunkId] + ".chunk.css";
};